import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'
import 'firebase/firestore'
const fb = require('../firebaseConfig.js')

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    curentUser: null,
    userProfile: {},
    trips: [],
    currentUser: {}
  },
  actions: {
    getTrips ({commit}) {
      const docRef = fb.db.collection('trip')
      let currentTrips = []
      docRef.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          let trip = doc.data()
          trip.id = doc.id
          currentTrips.push(trip)
          // doc.data() is never undefined for query doc snapshots
        })
        commit('setTrips', currentTrips)
      })
    },
    addTrip ({commit}, trip) {
      const docRef = fb.db.collection('trip')
      const random = Math.floor(Math.random() * Math.floor(100000))
      docRef.doc(random + trip.userId).set({
        name: trip.name,
        date: trip.date,
        time: trip.time,
        place: trip.place,
        type: trip.type,
        km: trip.km,
        den: trip.den,
        part: trip.part,
        userId: trip.userId
      }).then(res => {
        console.log('Document successfully written!')
      }).catch(error => {
        console.error('Error writing document: ', error)
      })
    },

    joinTrip ({commit}, join) {
      const docRef = fb.db.collection('users').doc(join.userId)
      docRef.update({
        trips: firebase.firestore.FieldValue.arrayUnion(join.tripId)
      }).then(result => {
        console.log(result)
      }).catch(err => {
        console.log(err)
      })
    },
    retireTrip ({commit}, join) {
      const docRef = fb.db.collection('users').doc(join.userId)
      docRef.update({
        trips: firebase.firestore.FieldValue.arrayRemove(join.tripId)
      }).then(result => {
        console.log(result)
      }).catch(err => {
        console.log(err)
      })
    },
    getUserInfo ({commit}, currentUser) {
      const docRef = fb.db.collection('users').doc(currentUser.uid)
      docRef.get().then(user => {
        if (user.exists) {
          let userData = user.data()
          commit('setUserProfile', userData)
          return userData
        } else {
          // If there is no data for this user, create a user profile
          docRef.set({
            email: currentUser.email,
            userId: currentUser.uid
          }).then(res => {
            console.log('Document successfully written!')
            return res.data()
          }).catch(error => {
            console.error('Error writing document: ', error)
            return error
          })
        }
      }).catch(error => {
        console.log('Error getting document:', error)
      })
    },
    updateUserProfile ({commit}, user) {
      const docRef = fb.db.collection('users').doc(user.userId)
      docRef.set({
        userId: user.userId,
        name: user.name,
        surname: user.surname,
        birth: user.birth,
        phone: user.phone
      }).then(res => {
        if (user.needImageUpdate) {
          // Upload the profile image
          const storage = firebase.storage()
          const storageRef = storage.ref()
          const userRef = storageRef.child('users/' + user.userId + '/profilePhoto.jpg')
          userRef.put(user.photoProfile).then(snapshot => {
            console.log('Photo de profil mis à jour!')
          })
          return res
        }
      }).catch(err => {
        throw err
      })
    }
  },
  mutations: {
    setCurrentUser (state, val) {
      state.currentUser = val
    },
    setUserProfile (state, val) {
      state.userProfile = val
    },
    setTrips (state, val) {
      state.trips = val
    }
  },
  getters: {
    trips: state => state.trips,
    userProfile: state => state.userProfile
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js